export default __webpack_public_path__ + "static/media/amount.5a88a493.svg";